"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteConfig = exports.getConfigs = exports.getConfig = exports.addConfig = void 0;
const shared_1 = require("@getgreenline/shared");
const setBaseUrl = (tenantId, retailerId) => {
    const url = `${shared_1.WORLDPAY_API_URL}/worldpay/tenants/${tenantId}`;
    return retailerId ? `${url}/retailers/${retailerId}/configs` : `${url}/configs`;
};
const addConfig = (tenantId, retailerId, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.post(setBaseUrl(tenantId, retailerId), payload);
    return res.data;
});
exports.addConfig = addConfig;
const getConfig = (tenantId, retailerId) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.get(setBaseUrl(tenantId, retailerId));
    return res.data;
});
exports.getConfig = getConfig;
const getConfigs = (tenantId) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.get(setBaseUrl(tenantId));
    return res.data;
});
exports.getConfigs = getConfigs;
const deleteConfig = (tenantId, retailerId) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.delete(setBaseUrl(tenantId, retailerId));
    return res.data;
});
exports.deleteConfig = deleteConfig;
//# sourceMappingURL=WorldpayConfigAPI.js.map